import { HStack, Text } from 'ui_2';
import { ArcadeTicketIcon } from './ArcadeTicketIcon';
import { useArcadeStoreState } from '@src/hooks/useArcadeStoreState';

export const ArcadeTicketBalance = () => {
  const { partBalance } = useArcadeStoreState();

  if (partBalance !== undefined) {
    return (
      <HStack className='items-center gap-2 rounded-[10px] border border-purple-100 bg-purple-100 px-3 py-2'>
        <ArcadeTicketIcon />
        <Text>{Number(partBalance.toFixed(0)).toLocaleString()}</Text>
        {/* <Text>{partBalancePending?.toFixed(0)}p</Text>
        <Text>{partBalanceTotal.toFixed(0)}t</Text>
        <Text>{unspentCount?.toFixed(0)}uc</Text>
        <Text>{pendingCount?.toFixed(0)}pc</Text>
        <Text>{totalCount?.toFixed(0)}tc</Text> */}
      </HStack>
    );
  }
};
